import React, { PropsWithChildren } from "react";
import Header from "./Header";

type Props = {
  showTagline?: boolean;
};

export default function Page({ children, showTagline = true }: PropsWithChildren<Props>) {
  return (
    <div style={{ background: "linear-gradient(#f7f7f8,#f3f3f6)" }}>
      <Header showTagline={showTagline} />
      <main className="page-container" style={{ maxWidth: 1000, margin: "20px auto 40px", padding: "0 16px" }}>
        {children}
      </main>
    </div>
  );
}
